import script from "./CLeftMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./CLeftMenu.vue?vue&type=script&setup=true&lang=ts"

import "./CLeftMenu.vue?vue&type=style&index=0&id=c8155778&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8155778"]])

export default __exports__